import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'doctor-call',
  templateUrl: './doctor-call.html',
  styleUrls: [],
  standalone: false,
})
export class DoctorCallComponent implements OnInit {
  constructor() { }
  ngOnInit(): void {
  }
}
